import { render, staticRenderFns } from "./DlgEventSendHostEmail.vue?vue&type=template&id=8d0df424"
import script from "./DlgEventSendHostEmail.vue?vue&type=script&lang=ts"
export * from "./DlgEventSendHostEmail.vue?vue&type=script&lang=ts"
import style0 from "./DlgEventSendHostEmail.vue?vue&type=style&index=0&id=8d0df424&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports